import axios from "axios";
import { Base_URL } from "../url";

export const saveReportingWbsDetails = async (wbsData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ReportingWbs/ReportingWbsReport?UserName=${username}`,
      wbsData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving reporting WBS details!";
  }
};